module.exports = __webpack_public_path__ + "static/media/bus.a0153417.svg";